import { FacilityTypeEnum } from '../facility-types/enums/facility-type';
import StyleConstants from '../../core/styles.constants';

// Colour and ordering for the linked-facilities view, following the approved facilities mockup:
// spaces are navy, equipment blue, anything with wheels amber. Purely presentational — the type
// itself always comes from the backend enum.
// Partial on purpose: a type the backend adds before the portal knows about it still renders,
// falling back to the neutral blue below.
const ACCENTS: Partial<Record<FacilityTypeEnum, string>> = {
  [FacilityTypeEnum.meetingRoom]: StyleConstants.DARK_BLUE_COLOR,
  [FacilityTypeEnum.silenceSpace]: StyleConstants.DARK_BLUE_COLOR,
  [FacilityTypeEnum.beamer]: StyleConstants.MEDIUM_BLUE_COLOR,
  [FacilityTypeEnum.display]: StyleConstants.MEDIUM_BLUE_COLOR,
  [FacilityTypeEnum.other]: StyleConstants.MEDIUM_BLUE_COLOR,
  [FacilityTypeEnum.car]: StyleConstants.ORANGE_COLOR,
  [FacilityTypeEnum.bicycle]: StyleConstants.ORANGE_COLOR,
  [FacilityTypeEnum.chargingStation]: StyleConstants.ORANGE_COLOR,
  [FacilityTypeEnum.parking]: StyleConstants.ORANGE_COLOR,
};

export const accentForFacilityType = (type: FacilityTypeEnum): string => ACCENTS[type] ?? StyleConstants.MEDIUM_BLUE_COLOR;

/** Reading order of the type groups: spaces first, then equipment, then transport, then the rest. */
export const FACILITY_TYPE_ORDER: FacilityTypeEnum[] = [
  FacilityTypeEnum.meetingRoom,
  FacilityTypeEnum.silenceSpace,
  FacilityTypeEnum.beamer,
  FacilityTypeEnum.display,
  FacilityTypeEnum.car,
  FacilityTypeEnum.bicycle,
  FacilityTypeEnum.chargingStation,
  FacilityTypeEnum.parking,
  FacilityTypeEnum.other,
];

/** Translation key for a type, e.g. `enums.facility-type-enum.meetingRoom`. */
export const facilityTypeLabelKey = (type: FacilityTypeEnum): string => `enums.facility-type-enum.${FacilityTypeEnum[type]}`;
